import React, { useState } from 'react';
import {
  ButtonsContainer,
  TitleAndSubtitle,
  ContentButtonsWrapper,
} from '../../../layout/layout-container.styled';
import { NavButton } from '../../../nav-button/nav-button';
import { Text, font } from '../../../../style-utils/text';
import { StyledInput } from '../../../styled-input/styled-input';
import { VisitorLogState } from '../../../hooks/use-visitor-log-handler';
import { DefaultComponentProps } from '../../../app-router/component-props';
import { palette } from '../../../../style-utils/theme';

export const NumberOfGuests: React.FC<DefaultComponentProps> = ({
  navigate,
  nextPath,
  prevPath,
  changeHandler,
  state,
}) => {
  const { numberOfGuests } = state as VisitorLogState;
  const [limitNote, setLimitNote] = useState('');

  return (
    <>
      <TitleAndSubtitle direction="column">
        <Text as="h1" fontSize={font.size.xl} fontWeight={700} mt={0} mb={8}>
          No. Of Guests
        </Text>
        <Text color={font.color.gray} fontSize={font.size.xs} mt={0} mb={0}>
          {/* Was "guest(s)/people" — a "(s)" and a slash doing the work of a
              sentence. There is no count to agree with here (this IS the field
              that collects it), so the plural is simply the right form. */}
          {'Type in the number of people'}
        </Text>
      </TitleAndSubtitle>
      <ContentButtonsWrapper>
        <StyledInput
          maxLength={2}
          width={70}
          placeholder={''}
          type="number"
          /* THE VALUE FROM STATE, not a hardcoded 1. `Slide` is keyed by
             pathname, so this step fully remounts every time it is reached —
             stepping back to correct the count showed "1" whatever had been
             entered, and going forward again re-sent it. */
          defaultValue={numberOfGuests}
          name={'numberOfGuests'}
          // eslint-disable-next-line
          onChange={(e: any) => {
            setLimitNote('');
            changeHandler(e, 'numberOfGuests');
          }}
          onReject={setLimitNote}
        />
        {limitNote ? (
          <Text
            color={palette.slate}
            fontSize={font.size.xs}
            mt={8}
            mb={0}
            role="status"
          >
            {limitNote}
          </Text>
        ) : null}
      </ContentButtonsWrapper>
      <ButtonsContainer>
        <NavButton
          disabled={false}
          direction="back"
          textColor={palette.slate}
          background="transparent"
          text={'Back'}
          onClick={() => navigate(prevPath, { replace: false })}
        />
        <NavButton
          disabled={numberOfGuests < 1}
          direction="forward"
          text={'Continue'}
          onClick={() => navigate(nextPath, { replace: false })}
        />
      </ButtonsContainer>
    </>
  );
};
